import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refrash--sprite",
  "use": "refrash--sprite-usage",
  "viewBox": "0 0 16 22",
  "content": "<symbol viewBox=\"0 0 16 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"refrash--sprite\">\n<path d=\"M8 3V0L4 4L8 8V5C11.31 5 14 7.69 14 11C14 12.01 13.75 12.97 13.3 13.8L14.76 15.26C15.54 14.03 16 12.57 16 11C16 6.58 12.42 3 8 3ZM8 17C4.69 17 2 14.31 2 11C2 9.99 2.25 9.03 2.7 8.2L1.24 6.74C0.46 7.97 0 9.43 0 11C0 15.42 3.58 19 8 19V22L12 18L8 14V17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol